/**
 * TEMPORARY SHOWCASE SAMPLES (owner 2026-11-04: "for testing ... 20 test images at the front of the gallery, iPhone
 * shape ... fake vault images so I can showcase it working"). FRONT-END ONLY: nothing is written to Caryn's server or
 * database. While on, the page adds sample photos to the FIRST page of the gallery (and the Home gallery button) and
 * sample items to the Vault; the real gallery and the fan's real purchases load right after them, unchanged.
 * ON only when built with VITE_SHOWCASE_SAMPLES=1 (the test links). scripts/build-production.mjs builds with it OFF and
 * refuses a bundle that still contains it. Remove this folder + its one line in src/main.tsx when no longer needed.
 */
import { API_URL } from '~/config/mode'

// single photos only (the design's grid-*.jpg files are screenshots of whole photo grids)
const PHOTOS = ['feature-1', 'feature-2', 'feature-3'].map((n) => `/design/gallery/${n}.jpg`)
const N = 20
const ago = (h: number) => new Date(Date.now() - h * 3600e3).toISOString()
const json = (body: unknown) => new Response(JSON.stringify(body), { status: 200, headers: { 'content-type': 'application/json' } })

/** phone-shaped (3:4 and 9:16 portrait) sample photos, the way iPhone pictures come in */
const samplePhotos = () => Array.from({ length: N }, (_, i) => {
  const src = PHOTOS[i % PHOTOS.length]
  const tall = i % 4 === 1 || i % 4 === 2
  return {
    id: `showcase-${i + 1}`, album_id: null, title: null, description: null,
    original_width: tall ? 1080 : 1536, original_height: tall ? 1920 : 2048, canvas_x: 0, canvas_y: 0,
    access_level: 'subscribers', dominant_color: '#3a3532', hasAccess: true, price: null,
    urls: { placeholder: null, thumbnail: src, medium: src, full: src, original: src },
    like_count: 12 + (i * 7) % 50, created_at: ago(i + 1), __showcase: true,
  }
})
const vaultPhoto = (i: number, title: string) => ({ id: `showcase-p${i}`, title, image_url: PHOTOS[i % PHOTOS.length], thumbnail_url: PHOTOS[i % PHOTOS.length], media_type: 'image' })
const samplePurchases = () => ['Golden hour set', 'Sweater weather', 'Joshua Tree mornings', 'Behind the scenes', 'Autumn walk', 'Just for you']
  .map((t, i) => ({ id: `showcase-purchase-${i}`, purchased_at: ago(24 * (i + 1)), photo: vaultPhoto(i, t) }))
const sampleFreebies = () => ['A little thank-you', 'Welcome gift']
  .map((t, i) => ({ id: `showcase-freebie-${i}`, unlocked_at: ago(24 * (i + 8)), freebie: vaultPhoto(i + 3, t) }))

export function installShowcaseSamples() {
  const real = window.fetch.bind(window)
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
    const method = String(init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase()
    if (!url.startsWith(API_URL)) return real(input, init)
    const u = new URL(url)
    // likes on a sample photo stay in the page (the server does not know these ids)
    if (/^\/api\/gallery\/images\/showcase-\d+\/like$/.test(u.pathname)) return json({ success: true, liked: method !== 'DELETE' })
    const res = await real(input, init)
    if (method !== 'GET' || !res.ok) return res
    try {
      if (u.pathname === '/api/gallery/images' && !u.searchParams.get('album_id') && (u.searchParams.get('offset') || '0') === '0') {
        const body = await res.clone().json()
        const limit = Number(u.searchParams.get('limit') || 60)
        const data = [...samplePhotos(), ...(body.data || [])].slice(0, Math.max(limit, N))
        return json({ ...body, data, pagination: body.pagination ? { ...body.pagination, total: (body.pagination.total || 0) + N } : body.pagination })
      }
      if (u.pathname === '/api/purchases') { const body = await res.clone().json(); return json({ ...body, data: [...samplePurchases(), ...(body.data || [])] }) }
      if (u.pathname === '/api/freebie-unlocks') { const body = await res.clone().json(); return json({ ...body, data: [...sampleFreebies(), ...(body.data || [])] }) }
    } catch { /* not JSON: leave the real answer alone */ }
    return res
  }
}

/** TEMPORARY (owner 11-04: "add me as a VIP for now so I can see the VIP badge on the live link"): these accounts show the
 *  VIP badge on the TEST LINKS only (same VITE_SHOWCASE_SAMPLES switch; production builds it off). Nothing is written. */
const SHOWCASE_VIP_EMAILS = ['divit.endal@gmail.com']
export const showcaseVip = (email?: string | null) =>
  import.meta.env.VITE_SHOWCASE_SAMPLES === '1' && !!email && SHOWCASE_VIP_EMAILS.includes(email.trim().toLowerCase())
